module.exports = __webpack_public_path__ + "static/img/contract_bg.7b0f598.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contract_bg.png
// module id = PL2P
// module chunks = 1